__webpack_require__.p = "/view-snapshot-counters/account-setup/";